import React, { useCallback, type FC } from 'react'

import { useAtom } from 'jotai'
import { useAtomCallback } from 'jotai/utils'
import { ModalConfirm } from 'mailup-web-components'
import { useIntl } from 'react-intl'

import { modalDeleteAtom } from 'Pages/unifiedFiltersListPage/state/state'

import {
  modalDeleteCloseCallback,
  modalDeleteConfirmCallback,
} from 'Pages/unifiedFiltersListPage/callbacks/modals'

const ModalDelete: FC = () => {
  const intl = useIntl()

  const [{ show }] = useAtom(modalDeleteAtom)

  const handleCancel = useAtomCallback(
    useCallback(modalDeleteCloseCallback, []),
  )
  const handleConfirm = useAtomCallback(
    useCallback(modalDeleteConfirmCallback, []),
  )

  return (
    <ModalConfirm
      data-mu-test='modal-delete-filter'
      showClose
      closeOnOverlayClick
      show={show}
      title={intl.formatMessage({ id: 'Load.ModalConfermeDelete.Title' })}
      message={intl.formatMessage({
        id: 'Load.ModalConfermeDelete.Description',
      })}
      stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
      stringConfirm={intl.formatMessage({ id: 'Load.MailupCommon.Delete' })}
      onClickCancel={handleCancel}
      onClickConfirm={handleConfirm}
      variant='delete'
    />
  )
}

export default ModalDelete
